import {
	RavenBadge,
	RavenCopyText,
	RavenNumberFormat,
	RavenTable,
	RavenTableRow,
} from '@ravenpay/raven-bank-ui';
import { merchantDetails } from './airtimeData';
import TwoDetailView from '../../../../../components/common/TwoDetailView';
import {
	capitalizeFirstLetter,
	capitalizeFirstWord,
	convertToLowercase,
	downloadCsvFile,
	formatDateHelper,
	formatMetaData,
	formatTypeFunction,
	identifyNetwork,
	trimLongString,
	// formatTypeFunction,
} from '../../../../../utils/helper/Helper';
import DateFragmentBox from '../../../../../components/common/DateFragmentBox';
import BadgeComponent from '../../../../../components/common/badge/BadgeComponent';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RootState from '../../../../../redux/types';
import settlementIcon from '../../../../../assets/bank_box_icon_settlement.svg';

import './airtimeIndex.css';

import BillsLayout from '../billslayout';
import AirtimeBillsModal from './AirtimeBillsModal';
import {
	getAirtimeRecords,
	searchAirtimeRecords,
} from '../../../../../redux/bills';
import Pagination from '../../../../../components/common/pagination';
import { debounce } from 'lodash';
import SmartFilter from '../../../../../components/common/smartFilter';
import TabLinksComponent from '../tabLinksComponent';
import ImageFragment from '../../../../../components/common/ImageFragment';
import ExportModal from '../../../../../components/common/exportModal';
import EmptyScreen from '../../../../../components/common/emptyScreen';
import Copy from '../../../../../components/common/copyCheck';
import CopyFragment from '../../../../../components/common/CopyFragment';
import AirtimeBil from '../billsModal';
// import Txreference from '../../../../../components/common/reference/TxRef';

const AirtimeBill = () => {
	const [currentPage, setCurrentPage] = useState(1);

	type showModalProp = {
		bills_modal: boolean;
		redu_modal: boolean;
	};
	const dispatch = useDispatch();

	const [showModal, setShowModal] = useState<showModalProp>({
		bills_modal: false,
		redu_modal: false,
	});
	const [singleChild, setSingleChild] = useState<any>({});

	const { airtimeRecords, loadingFetch } = useSelector(
		(state: RootState) => state.bills
	);
	const [showExport, setShowExport] = useState<boolean>(false);

	const [searchTerm, setSearchTerm] = useState('');

	useEffect(() => {
		fetchAllAirtime();
	}, [currentPage, searchTerm]);

	const fetchAllAirtime = async () => {
		const obj: any = {
			page: currentPage,
			perPage: 200,
			...(searchTerm && { search: searchTerm }),
		};

		try {
			let response;
			if (searchTerm) {
				response = await dispatch(searchAirtimeRecords(obj) as any);
			} else {
				response = await dispatch(getAirtimeRecords(obj) as any);
				// //(getAirtimeRecords);
			}

			// //('Fetched Airtime Data:', response);
		} catch (error) {
			console.error('Error fetching airtime records:', error);
		}
	};

	const csvHeader = [
		{ label: 'S/N', key: 'sn' },
		{ label: 'Business Name', key: 'merchant_name' },
		{ label: 'Business Email', key: 'merchant_email' },
		{ label: 'Type', key: 'type' },
		{ label: 'Amount', key: 'amount' },
		{ label: 'Account Name', key: 'account_name' },
		{ label: 'Account Number', key: 'account_number' },
		{ label: 'Bank', key: 'bank' },
		{ label: 'Transaction Reference', key: 'tranx_reference' },
		{ label: 'Transaction Details', key: 'transaction_details' },
		{ label: 'Date', key: 'created_at' },
		{ label: 'Status', key: 'status' },
	];

	return (
		<>
			<BillsLayout
			// noContentText={
			// 	"You don't have any record yet,your  bankbox airtime will be displayed here."
			// }
			// noContentTitle="No Airtime Record Found"
			// noContent={airtimeRecords?.data?.length < 1}
			// pageLoading={loadingFetch}
			>
				{/* dispute content start */}

				<div
					style={{ marginBottom: '1.5rem' }}
					className="global-search-pagination-filter-box"
				>
					{' '}
					<SmartFilter
						// hideExport
						searchTitle="Search By Email Address"
						defaultFilterBy="status"
						filters={[
							{
								label: 'Status',
								filterBy: 'status',
								options: [
									{ label: 'Pending', value: '1' },
									{ label: 'Failed', value: '2' },
									{ label: 'Successful', value: '3' },
									{ label: 'All Status', value: 'reset' },
								],
							},
						]}
						onExport={() => setShowExport(true)}
						page="airtime-records"
						onSearchChange={debounce((e) => {
							setSearchTerm(e);
						}, 500)}
					/>
					<div className="pagination-wrap">
						{' '}
						<Pagination
							className="top-bar__pagination"
							currentPage={currentPage}
							itemsPerPage={airtimeRecords?.pagination?.perPage ?? 0}
							totalItems={airtimeRecords?.pagination?.total ?? 0}
							onPageChange={function (page: number): void {
								setCurrentPage(page);
							}}
						/>
					</div>
				</div>
				{/* dispute content end */}

				<div className="fee-detail-dashboard-content-index-wrap">
					{airtimeRecords?.data?.length < 1 ? (
						<EmptyScreen
							loading={loadingFetch}
							loadingText={loadingFetch ? 'Searching...' : 'Loading Bills...'}
							title="No Airtime Records Found"
							subTitle="You don't have any record yet, your new bankbox transactions will be displayed here."
						/>
					) : (
						<div className="transaction__table non-mobile">
							<RavenTable
								action={false}
								className="table__main"
								headerList={[
									'MERCHANT DETAILS',
									'REFERENCE',
									'PROVIDER',
									'AMOUNT',
									'MOBILE NUMBER',
									'DATE',
									'STATUS',
								]}
							>
								{airtimeRecords?.data?.map((chi: any, idx: any) => (
									<RavenTableRow
										key={idx}
										loading={loadingFetch}
										onRowClick={() => {
											setSingleChild(chi);
											setShowModal((prev) => {
												return { ...prev, bills_modal: true };
											});
										}}
										one={
											<TwoDetailView
												title={
													capitalizeFirstWord(chi?.merchant_name || '---') ||
													'----'
												}
												text_one={chi.email || '---'}
											/>
										}
										two={
											<>
												{chi?.merchant_ref ? (
													<RavenCopyText
														text={chi?.merchant_ref}
														copyValue={chi?.merchant_ref}
														trimNum={35}
														clickable
														stopPropagation
														color="deep-green-light"
														copyIconColor="var(--primary-base-color)"
														copyIconBgColor="var(--primary-accent-color-one)"
														copiedBgColor=" var(--primary-base-color)"
													/>
												) : (
													'---'
												)}
												{/* {chi?.merchant_ref ? (
													<RavenCopyText
														text={chi?.merchant_ref}
														copyValue={chi?.merchant_ref}
													/>
												) : (
													'---'
												)} */}
											</>
										}
										three={
											<div className="provider_image_and_name">
												<ImageFragment
													className={`img-val-box img-box border-theme`}
													url={`https://personalbanking.getraventest.com/static/media/mobile/${convertToLowercase(
														identifyNetwork(
															formatMetaData(chi?.meta_data)?.phone_number
														)
													)}.png`}
												>
													<figure className="img-box border-theme">
														<img
															className="img"
															src={settlementIcon}
															alt="image"
														/>
													</figure>
												</ImageFragment>
												<p className="name">
													{identifyNetwork(
														formatMetaData(chi?.meta_data)?.phone_number
													)}
												</p>
											</div>
										}
										four={RavenNumberFormat(chi?.amount || 0)}
										five={formatMetaData(chi?.meta_data)?.phone_number || '---'}
										six={<DateFragmentBox date={chi?.created_at} />}
										seven={
											<div className="status_and_modal_holder">
												<RavenBadge
													text={`${
														String(chi?.status) === '1'
															? 'Pending'
															: String(chi?.status) === '2'
															? 'Failed'
															: String(chi?.status) === '3'
															? 'Successful'
															: 'Pending'
													}`}
													type={`${
														String(chi?.status) === '1'
															? 'yellow'
															: String(chi?.status) === '2'
															? 'red'
															: String(chi?.status) === '3'
															? 'green'
															: 'yellow'
													}`}
												/>
											</div>
										}
									/>
								))}
							</RavenTable>
						</div>
					)}
				</div>
				{/* table content end */}
			</BillsLayout>

			<AirtimeBil
				singleObj={singleChild}
				isLoadingDetails={true}
				transactionType={singleChild?.type || '---'}
				visible={showModal.bills_modal}
				onClose={() =>
					setShowModal((prev) => ({
						...prev,
						bills_modal: false,
					}))
				}
				singleChildren={singleChild} // Pass selected transaction
				title={'Transaction Details'}
				amount={singleChild?.amount || 0}
				businessEmail={singleChild?.email || 'N/A'}
				type={singleChild?.type || '---'}
				fee={singleChild?.fee || 0}
				mobileNumber={singleChild?.phone_number || '---'}
				provider={
					singleChild?.type === 'electricity'
						? formatMetaData(singleChild?.meta_data)?.provider || '---'
						: singleChild?.provider || '---'
				}
				reference={singleChild?.reference}
				merchantRef={singleChild?.merchant_ref || '---'}
				status={
					<RavenBadge
						text={`${
							String(singleChild?.status) === '1'
								? 'Pending'
								: String(singleChild?.status) === '2'
								? 'Failed'
								: String(singleChild?.status) === '3'
								? 'Successful'
								: 'Pending'
						}`}
						type={`${
							String(singleChild?.status) === '1'
								? 'yellow'
								: String(singleChild?.status) === '2'
								? 'red'
								: String(singleChild?.status) === '3'
								? 'green'
								: 'yellow'
						}`}
					/>
				}
				date={
					singleChild?.created_at
						? new Date(singleChild?.created_at).toLocaleDateString()
						: '---'
				}
				btnLabel="Download Receipt"
				btnColor="green-light"
			/>

			<ExportModal
				onClose={() => setShowExport(false)}
				visible={showExport}
				page="airtime-records"
				onFinishExport={(param) => {
					// formatExportData(param);
					window.open(param, '_blank')?.focus();
				}}
			/>
		</>
	);
};
export default AirtimeBill;
